module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODxoaf0zN4AAAAPBJREFUOMvtktFqAjEQRc+km5J+VsR+dY2yVXT/Z5XVzSTjS10oWmnxoVB6YV4uw+HOZaQ/HIwH1Tjn+EOQJ3kc8jgBcOIEcYIWZb1ZU61y8UottO8tWfPk3RrnRHAidLsdfd+TUsJqpZZCSon9fk/XdVz2bo2YmQGoKouUGMeREAICDMcj3nte53OapvnynAkCUGslLZcMwwBACIFZjHcBV8WWUqi1/rjYKUnOmbfFAlXlJQQQYRiGb50zJVlvNqgq3ntijMxi5Nl7VJXtdns/in3odDrZcrWycRwvluWcrW1bU1W7p0/F/u7H/kOudAY1ua6xJgbfogAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/clear-over_20.png
 ** module id = 257
 ** module chunks = 0 1
 **/